import BadgesInfoDataset from "../badgesDatasets/badges_info_dataset";
export const determineNextBadge = (badgesEarned) => {
    // badges earned is from the games collection
    const badgeArr = BadgesInfoDataset;
    let nextBadge = badgesEarned.length + 1;
    let badgeParameters = badgeArr[nextBadge - 1];
    const returnObj = {badgeParameters: badgeParameters, nextBadge: nextBadge};
    return returnObj;
}
export default determineNextBadge;